import { render, staticRenderFns } from "./bottomRight.vue?vue&type=template&id=5f58edb3&scoped=true&"
import script from "./bottomRight.vue?vue&type=script&lang=js&"
export * from "./bottomRight.vue?vue&type=script&lang=js&"
import style0 from "./bottomRight.vue?vue&type=style&index=0&id=5f58edb3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f58edb3",
  null
  
)

export default component.exports